// extracted by mini-css-extract-plugin
export default {"container":"SellAdvert_container__Vf8qr","ASide":"SellAdvert_ASide__VaU3j","BSide":"SellAdvert_BSide__ePj6M","headingContainer":"SellAdvert_headingContainer__+r4ea"};